import React, { useState } from "react";
import "./FaqItem.css";
import { ArrowDown, ChevronDown, Dribbble, MessageCircle } from "react-feather";

const FAQItem = ({ question, answer, index }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="faq-item">
      <div className="question_faq" onClick={toggleAccordion}>
        <span>{question}</span>
        <ChevronDown className={`dropdown-icon ${isOpen ? "open" : ""}`} />
      </div>
      {isOpen && <div className="answer_faq">{answer}</div>}
    </div>
  );
};

export default FAQItem;
